import React from "react";
import "./Modal.css";
import Logo from "../../img/logo.png"

const Modal = ({ closeModal, heading, detail }) => {
  // Gérer la fermeture de la modal sans propagation d'événement
  const handleCloseModal = (e) => {
    e.stopPropagation(); // Arrêter la propagation des événements de clic à l'intérieur de la modal
    closeModal(); // Fermer la modal
  };

  return (
    <div className="modal-background2" onClick={handleCloseModal}>
      <div className="modal-content2" onClick={(e) => e.stopPropagation()}>
        <h2 style={{color:"#4cb6ea",fontWeight:"bold"}}>{heading}</h2>
        <p>{detail}</p>
       <div style={{display:"flex", flexDirection:"column",justifyContent:"center", alignItems:"center"}}>
       <img className="imgDivmodal2" style={{ width: "15rem", height: "15rem" }} src={Logo} alt="" />

<button style={{background:"#4cb6ea"}} className="modal-close2" onClick={handleCloseModal}>
  Fermer 
</button>
       </div>
      </div>
    </div>
  );
};

export default Modal;
